import React from "react";
import DocumentTitle from "react-document-title";
import Link from "../components/Link";
import PageHero from "../components/PageHero";
import PageHeroContentSection from "../components/PageHeroContentSection";
// NOTE: Leaving this here in case we're adding another component to replace ApartmentStoryCTA
// import ApartmentStoryCTA from "../components/ApartmentStoryCTA";
import { getPageTitle } from "../utility/utility";
// import winnerBadge from "../images/icon-winner-badge.png";
import "./Home.scss";

export default class HomePage extends React.Component {
  static pageTitle(listings, routeParams) {
    // eslint-disable-line no-unused-vars
    return "Fort Greene Brooklyn New Luxury Apartments | 300 Ashland Pl";
  }

  render() {
    const promotion = null;

    return (
      <DocumentTitle title={getPageTitle(this.constructor, this.props)}>
        <div className="content" id="main" role="main">
          <PageHero noContentBelow imgOverlay={promotion}>
            <PageHeroContentSection>
              <div>
                <h2 className="h1">
                  <span className="accented-text">Unlike Anything</span>
                  in The Middle of Everything
                </h2>
                <p>
                  Designed to connect modern residences with the Fort Greene
                  community, 300 Ashland is centrally located at a unique
                  triangular intersection in the heart of the Brooklyn Cultural
                  District.
                </p>
                <Link to="/availability" tabIndex="0">
                  View Availabilities
                </Link>
              </div>
            </PageHeroContentSection>
            {/*<PageHeroContentSection adopt={true}>
              <ApartmentStoryCTA />
            </PageHeroContentSection>*/}
          </PageHero>
        </div>
      </DocumentTitle>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/Home.js